export default __webpack_public_path__ + "static/media/cancel-icon.c1cd8fca.svg";